import * as React from 'react';

const rtf = new Intl.RelativeTimeFormat(navigator.language, {
  numeric: 'auto',
});

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;

const TIME_UNITS = [
  { limit: MINUTE, divisor: SECOND, unit: 'second', interval: SECOND },
  { limit: HOUR, divisor: MINUTE, unit: 'minute', interval: MINUTE },
  { limit: DAY, divisor: HOUR, unit: 'hour', interval: HOUR },
  { limit: WEEK, divisor: DAY, unit: 'day', interval: DAY },
] as const;

export const rtfAuto = (time: Date) => {
  const ms = time.valueOf() - Date.now();
  const absMs = Math.abs(ms);

  for (const { limit, divisor, unit } of TIME_UNITS) {
    if (absMs < limit) {
      return rtf.format(Math.round(ms / divisor), unit);
    }
  }

  // For times beyond a week, return the formatted date string.
  return time.toLocaleString();
};

export const RtfAuto = ({ time }: { time: Date }) => {
  const [relativeTime, setRelativeTime] = React.useState(() => rtfAuto(time));

  React.useEffect(() => {
    const updateRelativeTime = () => setRelativeTime(rtfAuto(time));

    // Determine the appropriate interval based on the current difference in time
    const ms = time.valueOf() - Date.now();
    const absMs = Math.abs(ms);

    const interval =
      TIME_UNITS.find(({ limit }) => absMs < limit)?.interval ?? WEEK;

    updateRelativeTime();
    const id = setInterval(updateRelativeTime, interval);

    return () => clearInterval(id);
  }, [time]);

  return <>{relativeTime}</>;
};
